import { useState } from "react";
import RightArrowExtendedIconSVG from "../../../SharedComponents/assets/icons/svg/RightArrowExtendedIconSVG";
import BaseButton from "../../../SharedComponents/components/Buttons/BaseButton";
import { ButtonVariantEnum } from "../../../SharedComponents/utils/enums/ButtonVariantEnum";
import PlusIconSVG from "../../../SharedComponents/assets/icons/svg/PlusIconSVG";
import { getSrcUrlFromFile } from "../../../SharedComponents/utils/helpers/getSrcUrlFromFile";
import TrashBinIconSVG from "../../../BuyerStack/assets/icons/svg/TrashBinIconSVG";
import ReviewOffer from "./ReviewOffer";
import api from "../../../../api";
import { ulid } from "ulid";
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';




const CreatePartOffer = () => {
    const [selectedImages, setSelectedImages] = useState([]);
    const [showReview, setShowReview] = useState(false);
    const location = useLocation();
    const { id } = location.state || {};
    const navigate = useNavigate();



    const [formData, setFormData] = useState({
        description: "",
        price: "",
        currency: "rsd",
        guarantee: "",
        type: "",
        deliveryOptions: []
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleDeliveryOptionChange = (e) => {
        const { value, checked } = e.target;
        setFormData(prev => {
            if (checked) {
                return {
                    ...prev,
                    deliveryOptions: [...prev.deliveryOptions, value]
                };
            } else {
                return {
                    ...prev,
                    deliveryOptions: prev.deliveryOptions.filter(option => option !== value)
                };
            }
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setShowReview(true);
    };

    const handleFinalSubmit = async () => {
        try {
            let deliveryOption;
            const data = new FormData();
            data.append("description", formData.description);
            data.append("price", formData.price);
            data.append("currency", formData.currency);
            data.append("guarantee", formData.guarantee);
            data.append("type", formData.type);
            data.append("part_request_id", id);
            data.append("ulid", ulid());

            if (formData.deliveryOptions === "kurir") {
                deliveryOption = "kurir";
            } else if (formData.deliveryOptions === "lično") {
                deliveryOption = "lično";
            } else {
                deliveryOption = "oba";
            }

            data.append("delivery", deliveryOption);

            selectedImages.forEach((image) => {
                data.append("images", image);
            });

            const response = await api.post("/partoffer-seller", data, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            const createdOfferId = response.data?.part_offer_id;

            if (!createdOfferId) {
                throw new Error("ID nije vraćen iz POST odgovora");
            }

            alert("Ponuda je uspešno poslata!");
            setShowReview(false);
            navigate('/offer-review', { state: { id: createdOfferId } });

        } catch (error) {
            console.error("Greška prilikom slanja ponude:", error);
            alert("Došlo je do greške prilikom slanja ponude.");
        }
    };

    const GetSelectedImageStack = (file, setState) => {
        return (
            <div style={styles.InputContainer}>
                <div style={styles.ImageContainer}>
                    <img
                        src={getSrcUrlFromFile(file)}
                        style={styles.Image}
                    />
                    <div
                        onClick={setState}
                        style={styles.trashBinSvgContainer}
                    >
                        <TrashBinIconSVG />
                    </div>
                </div>
            </div>
        );
    };

    const GetSelectedImagesStack = () => {
        return selectedImages.map((file) => {
            const setStateCallback = (oldVal) => {
                return oldVal.filter((oldFile) => oldFile.name !== file.name);
            };
            return GetSelectedImageStack(file, () => setSelectedImages(setStateCallback));
        });
    };

    const handleImageUpload = (newFiles) => {
        setSelectedImages((prev) => {
            const newUniqueFiles = newFiles.filter(
                (newFile) => !prev.some((existing) => existing.name === newFile.name)
            );
            return [...prev, ...newUniqueFiles];
        });
    };

    const selectedImagesAreNotEmpty = selectedImages.length > 0;

    if (showReview) {
        return (
            <ReviewOffer
                formData={formData}
                selectedImages={selectedImages}
                onBack={() => setShowReview(false)}
                onSubmit={handleFinalSubmit}
            />
        );
    }

    return (
        <form onSubmit={handleSubmit}>
            <div>
                <h3 style={styles.header}>Opiši deo koji nudiš</h3>
                <textarea
                    style={styles.inputBox}
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                />

                <div style={styles.currencySelector}>
                    <input
                        style={styles.price}
                        placeholder="Unesi cenu"
                        name="price"
                        value={formData.price}
                        onChange={handleInputChange}
                    />
                    <select
                        name="currency"
                        style={styles.currencyPicker}
                        value={formData.currency}
                        onChange={handleInputChange}
                    >
                        <option value="rsd">RSD</option>
                        <option value="eur">EUR</option>
                    </select>
                </div>

                <select
                    name="guarantee"
                    style={styles.guarantee}
                    value={formData.guarantee}
                    onChange={handleInputChange}
                >
                    <option value="" disabled hidden>
                        Garancija
                    </option>
                    <option value="3 meseca">3 meseca</option>
                    <option value="6 meseci">6 meseci</option>
                    <option value="1 godina">1 godina</option>
                    <option value="2 godine">2 godine</option>
                </select>

                <div style={styles.radioGroup}>
                    <div style={styles.radioOption}>
                        <input
                            type="radio"
                            name="type"
                            value="new"
                            checked={formData.type === "new"}
                            onChange={handleInputChange}
                            style={styles.inputOne}
                        />
                        <label style={styles.label}>Nov deo</label>
                    </div>
                    <div style={styles.radioOption}>
                        <input
                            type="radio"
                            name="type"
                            value="used"
                            checked={formData.type === "used"}
                            onChange={handleInputChange}
                            style={styles.inputOne}
                        />
                        <label style={styles.label}>Polovan deo</label>
                    </div>
                </div>

                <h3 style={styles.header}>Transport</h3>
                <div style={styles.checkboxGroup}>
                    <div style={styles.checkboxOption}>
                        <input
                            type="checkbox"
                            name="deliveryOption"
                            value="lično"
                            checked={formData.deliveryOptions.includes("lično")}
                            onChange={handleDeliveryOptionChange}
                            style={styles.inputTwo}
                        />
                        <label style={styles.label}>Lično</label>
                    </div>
                    <div style={styles.checkboxOption}>
                        <input
                            type="checkbox"
                            name="deliveryOption"
                            value="kurir"
                            checked={formData.deliveryOptions.includes("kurir")}
                            onChange={handleDeliveryOptionChange}
                            style={styles.inputTwo}
                        />
                        <label style={styles.label}>Kurir</label>
                    </div>
                </div>

                <h3 style={styles.header}>Slike</h3>
                <div style={styles.imageComponent}>
                    <p style={styles.title}>Slike</p>
                    <div style={styles.imageStack}>
                        {selectedImagesAreNotEmpty && GetSelectedImagesStack()}
                    </div>
                </div>
                <BaseButton
                    variant={ButtonVariantEnum.WHITE}
                    text={"Dodaj slike"}
                    IconComponent={PlusIconSVG}
                    type={"file"}
                    onClick={handleImageUpload}
                />

                <div style={styles.buttonContainer}>
                    <button style={styles.confirmButton} type="submit">
                        <div style={styles.button}>Potvrdi ponudu</div>
                        <div style={styles.inputOne}>
                            <RightArrowExtendedIconSVG />
                        </div>
                    </button>
                    <p>U sledećem koraku proveri i pošalji ponudu</p>
                </div>
            </div>
        </form>
    );
};

const styles = {
    header: {
        fontSize: "24px",
        color: "rgba(0, 0, 0, 0.87)",
        fontWeight: "bold",
        marginTop: "39px",
    },
    inputBox: {
        padding: "16px",
        fontSize: "14px",
        lineHeight: "1.5",
        width: "100%",
        height: "250px",
        boxSizing: "border-box",
        border: "1px solid #ccc",
        borderRadius: "4px",
        resize: "none",
    },
    inputOne: {
        scale: "140%"
    },
    inputTwo: {
        scale: "160%"
    },
    currencySelector: {
        display: "flex",
        marginTop: "10px",
        width: "150%",
        alignItems: "center",
    },
    price: {
        borderRadius: "4px",
        border: "1px solid #ccc",
        height: "50px",
        padding: "10px",
        width: "25%",
        fontSize: "20px",
    },
    currencyPicker: {
        borderRadius: "4px",
        border: "1px solid #ccc",
        height: "50px",
        marginLeft: "20px",
        width: "15%",
        padding: "8px",
        opacity: "70%",
    },
    guarantee: {
        borderRadius: "4px",
        border: "1px solid #ccc",
        height: "50px",
        marginTop: "20px",
        width: "50%",
        padding: "8px",
        opacity: "70%",
    },
    radioGroup: {
        display: "flex",
        gap: "20px",
        alignItems: "center",
        marginTop: "10px",
        paddingLeft: "5px",
    },
    radioOption: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
    },
    checkboxGroup: {
        display: "flex",
        gap: "50px",
        alignItems: "center",
        marginTop: "10px",
        paddingLeft: "5px",
    },
    checkboxOption: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
    },
    buttonContainer: {
        marginTop: "20px",
        width: "80%"
    },
    button: {
        padding: "20px"
    },
    confirmButton: {
        display: "flex",
        fontSize: "25px",
        padding: "5px",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "6px",
        fontWeight: "bold",
        cursor: "pointer",
        marginBottom: "10px",
        color: "#FFFFFF",
        height: "70px",
        backgroundColor: "rgba(0, 0, 0, 0.91)",
    },
    InputContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        width: 'max-content'
    },
    ImageContainer: {
        width: 75,
        height: 75,
        overflow: 'hidden',
        position: 'relative'
    },
    imageComponent: {
        marginTop: 40,
        marginBottom: 30
    },
    imageStack: {
        display: 'flex',
        alignItems: 'center',
        gap: "10",
        marginTop: "40",
        maxHeight: "20px",
        maxWidth: "10px"
    },
    Image: {
        objectFit: 'cover',
        width: "100%",
        height: "100%",
        borderRadius: 4
    },
    trashBinSvgContainer: {
        position: 'absolute',
        cursor: 'pointer',
        backgroundColor: "#FFFFFF",
        bottom: 4,
        right: 4,
        paddingInline: 4,
        borderRadius: 4
    },
    label: {
        fontSize: "18px",
        color: "black",
        paddingTop: "8px"
    }
};

export default CreatePartOffer;
